import React, { useState } from 'react'
import { LabelText } from '$components/Services/styledComponents'
import { useUser } from '$context/user'
import DownloadFiles from '$components/Services/OrderedServicesDetails/DownloadFiles'
import { Button, Col, Divider, Row, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const { TextArea } = Input

const Generate3DModelDetails = ({
  record,
  theme,
  onAcceptOrder,
  onRejectOrder,
  isOrderAccepted = false,
  isOrderRejected = false,
  isMyServicesPage = false,
}) => {
  const { isServiceProvider } = useUser()
  const { t } = useTranslation()
  const [rejectReason, setRejectReason] = useState('')
  const maxChars = 200

  const handleRejectReasonChange = (e) => {
    const value = e.target.value
    if (value.length <= maxChars) {
      setRejectReason(value)
    }
  }

  const handleAccept = () => {
    onAcceptOrder && onAcceptOrder()
  }

  const handleReject = () => {
    if (rejectReason.trim().length > 0) {
      onRejectOrder && onRejectOrder(rejectReason)
    }
  }

  const isEditable = !isOrderAccepted && !isOrderRejected

  const renderInfoSection = () => {
    if (isServiceProvider && isOrderRejected) {
      return (
        <>
          <LabelText>{t('info')}</LabelText>
          <p
            style={{
              color: theme.colorBrightRed500 ?? 'red',
              fontSize: '15px',
            }}
          >
            {t('bookedservices.rejected_by_provider')}
          </p>
          <p
            style={{
              color: theme.colorBrightRed500 ?? 'red',
              fontSize: '12px',
            }}
          >
            {record.provider_rejection_reason}
          </p>
          <Divider />
        </>
      )
    }
    if (isServiceProvider && isEditable) {
      return (
        <>
          <LabelText>{t('info')}</LabelText>
          <p>{t('bookedservices.execute_service')}</p>
          <Divider />
        </>
      )
    }
    return (
      <LabelText>{t('bookedservices.generate_3d_model.selected')}</LabelText>
    )
  }

  return (
    <Row style={{ width: '100%' }}>
      <Col span={12} style={{ paddingRight: 30 }}>
        {record?.user_file_locations?.length > 0 && (
          <DownloadFiles record={record} style={{ marginBottom: '18px' }} />
        )}
        <LabelText>{t('bookedservices.specs_headline')}</LabelText>
        <p>{record.specifications}</p>
      </Col>
      <Col span={12}>
        {t('bookedservices.generate_3d_model.the_customer_has_selected')}
        <ul>
          {record.information_quality.map((str, index) => (
            <li key={index}>{str}</li>
          ))}
        </ul>

        {record.information_quality.includes('delivery') && (
          <>
            <p>
              {t('bookedservices.generate_3d_model.client_selected_send_part')}
            </p>
            <p>
              <b>{record.tracking_number}</b>
            </p>
            {record.send_back === true ? (
              <>
                <p>{t('bookedservices.generate_3d_model.send_back')}</p>
                <div>{record.address.name}</div>
                <div>{record.address.address_line_1}</div>
                <div>{record.address.address_line_2}</div>
                <div>
                  {record.address.postcode} {record.address.city}
                </div>
                <div>{record.address.state}</div>
                <p>{record.address.country}</p>
              </>
            ) : (
              <p>{t('bookedservices.generate_3d_model.not_send_back')}</p>
            )}
          </>
        )}
        {isServiceProvider &&
        isEditable &&
        record.status_info !== 'rejected' &&
        !isMyServicesPage ? (
          <>
            <Divider />
            <LabelText>{t('info')}</LabelText>
            <p>{t('bookedservices.please_accept_or_reject_order')}</p>
            <Row style={{ marginBottom: '16px' }}>
              <LabelText>{t('bookedservices.rejection_reason')}</LabelText>
              <TextArea
                value={rejectReason}
                onChange={handleRejectReasonChange}
                placeholder={t('bookedservices.rejection_reason')}
                rows={3}
                maxLength={maxChars}
                disabled={isOrderRejected}
              />
              <div
                style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}
              >
                {t('bookedservices.only_x_chars_allowed', { count: maxChars })}
              </div>
              <div style={{ marginTop: '5px' }}>
                <Button
                  type="primary"
                  onClick={handleAccept}
                  style={{ marginRight: '8px', marginBottom: '5px' }}
                >
                  {t('bookedservices.accept_and_continue_button')}
                </Button>
                <Button
                  danger
                  onClick={handleReject}
                  disabled={rejectReason.trim().length === 0}
                >
                  {t('bookedservices.reject_and_close_button')}
                </Button>
              </div>
              <Divider />
            </Row>
          </>
        ) : (
          renderInfoSection()
        )}
      </Col>
    </Row>
  )
}

Generate3DModelDetails.propTypes = {
  theme: PropTypes.shape({
    colorBrightRed500: PropTypes.string,
  }),
  record: PropTypes.shape({
    provider_rejection_reason: PropTypes.string,
  }),
}

export default Generate3DModelDetails
